export default __webpack_public_path__ + "static/media/logo_letter_blue.aa4059b5.svg";